import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/clients/forgot.css";
import { showToast } from '../../utils/toastUtils';
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as LogoSvg } from "../../assets/icons/Logo.svg";
import { CircleChevronLeft } from "lucide-react";
import { AuthService } from "../../services/auth";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;

    const looksLikeEmail = /.+@.+\..+/.test(email);
    if (!looksLikeEmail) {
      showToast.error("Vui lòng nhập email hợp lệ.");
      return;
    }

    try {
      setIsSubmitting(true);
      await AuthService.forgotPassword({ email });
      showToast.success(
        "Đã gửi email đặt lại mật khẩu! Vui lòng kiểm tra hộp thư."
      );
      setTimeout(() => navigate("/dang-nhap"), 1500);
    } catch (error) {
      const message =
        error instanceof Error
          ? error.message
          : "Không thể gửi email. Vui lòng thử lại sau.";
      showToast.error(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="forgot-page">
      <div className="forgot-left">
        <img
          src={require("../../assets/images/image-login.png")}
          alt="illustration"
          className="illustration-full"
        />
      </div>
      <div className="forgot-right">
        <div className="back-home-link-wrapper">
          <button
            type="button"
            className="back-home-link"
            onClick={() => navigate("/dang-nhap")}
          >
            <CircleChevronLeft size={18} className="back-home-link-icon" />
            <span className="back-home-link-text">Quay lại đăng nhập</span>
          </button>
        </div>
        <div className="forgot-logo">
          <LogoSvg
            style={{ width: "300", height: "100", marginBottom: "2rem" }}
          />
        </div>
        <h1 className="forgot-title">Quên mật khẩu</h1>
        <form onSubmit={handleSubmit} className="forgot-form">
          <div className="form-group">
            <label htmlFor="email">Nhập email của bạn</label>
            <input
              id="email"
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="action-container">
            <button className="action-btn" type="submit" disabled={isSubmitting} aria-busy={isSubmitting}>
              {isSubmitting ? "Đang gửi..." : "Gửi liên kết đặt lại mật khẩu"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
